export default __webpack_public_path__ + "static/media/loading-gear.00da0785.gif";